import {FC, useRef, useEffect, useState, PropsWithChildren} from 'react'
import {shallowEqual, useSelector, connect, useDispatch, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as auth from './AuthRedux'
import {getUserByToken} from './AuthCRUD'
import {RootState} from '../../../../setup'
import {useLocation} from 'react-router-dom'
import * as rfSatuanKerjaRedux from '../../rf-satuan-kerja/index'

const mapState = (state: RootState) => ({auth: state.auth})
const connector = connect(mapState, auth.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const AuthInit: FC<PropsFromRedux & PropsWithChildren> = (props) => {
  const didRequest = useRef(false)
  const dispatch = useDispatch()
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  const accessToken = useSelector<RootState>(({auth}) => auth.accessToken, shallowEqual)

  let location = useLocation()

  // We should request user by authToken before rendering the application
  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          if (location.pathname.includes('ssoauthorization')) {
            const url = location.pathname.split('/')
            const accessToken = url[url.length - 1]

            dispatch(props.login(accessToken))
            // dispatch(rfSatuanKerjaRedux.actions.initRFSatuanKerja())
          } else {
            const {data: user} = await getUserByToken(accessToken as string)
            dispatch(props.fulfillUser(user))
            // dispatch(rfSatuanKerjaRedux.actions.initRFSatuanKerja())
          }
        }
      } catch (error) {
        console.error(error)
        if (!didRequest.current) {
          dispatch(props.logout())
        }
      } finally {
        setShowSplashScreen(false)
      }

      return () => (didRequest.current = true)
    }

    if (accessToken || location.pathname.includes('ssoauthorization')) {
      requestUser()
    } else {
      dispatch(props.logout())
      setShowSplashScreen(false)
    }
    // eslint-disable-next-line
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(AuthInit)
